import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const validUsers = ["IVAN", "KEN", "EDWARD"];

  const onFinish = async (values) => {
    setLoading(true);
    
    try {
      const { username } = values;
      
      
      if (!username) {
        message.error('Username is required');
        setLoading(false);
        return;
      }
      
      
      const formattedUsername = username.trim().toUpperCase();
      
      if (validUsers.includes(formattedUsername)) {
        
        const success = await onLogin(formattedUsername);
        if (success) {
          message.success(`Welcome, ${formattedUsername}!`);
          form.resetFields(); 
        }
      } else {
        message.error('Invalid username. Please enter: IVAN, KEN, or EDWARD');
      }
    } catch (error) {
      console.error('Login error:', error);
      message.error('An error occurred during login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card bordered={false}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: 30 }}>
          Task Management System
        </Title>
        <Form
          name="login"
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: 'Please enter your username',
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  
                  const formatted = value.trim().toUpperCase();
                  if (validUsers.includes(formatted)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Invalid username.'));
                }
              }
            ]}
          >
            <Input 
              prefix={<UserOutlined className="site-form-item-icon" />} 
              placeholder="Username" 
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              size="large" 
              block
            >
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;